import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Sync"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-sync',
    templateUrl: './icon-cash-sync.component.html',
    styleUrls: ['./icon-cash-sync.component.scss'],
    standalone: false
})
export class IconCashSyncComponent {
/**
 * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
 *
 * @param tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Input() tooltip?: string;
}
